export const SUCCESS = 0;
export const USER_NOT_FOUND = 2000;
export const SIGNED_OUT = 2029;
export const USER_BLOCKED = 2010;
export const ACCESS_RIGHTS_ERROR = 4;
export const LAST_QUESTION_IN_PROGRESS = 2037;
export const GAME_REQUIRES_FULL_ACCOUNT = 2038;
